module.exports = __webpack_public_path__ + "static/media/FR-39.003516ee.geojson";